import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useReactMediaRecorder } from '../../hooks/useMediaRecorder';
import { Button } from 'rsuite';
import ViewFinder from './ViewFinder';
import {
  clearUploadedVideo,
  completeRecording,
  getPreSignedUrlForUpload,
  getShouldShowCameraRecorder,
  hideCameraRecorder,
  selectVideo,
} from '../../redux/modules/campaignLandingPage';
import styles from './CameraRecord.module.less';

const CameraRecord = ({
  _clearUploadedVideo,
  _completeRecording,
  _hideCameraRecorder,
  _selectVideo,
  qid,
  shouldShowCameraRecorder,
}) => {
  if (!shouldShowCameraRecorder) {
    return null;
  }

  const {
    status,
    startRecording,
    stopRecording,
    mediaBlobUrl,
    previewStream,
  } = useReactMediaRecorder({
    video: {
      facingMode: "user",
      width: 1920,
      height: 1080,
    },
  });

  useEffect(() => {
    // if the object URL has updated,
    // dispatch it to the store
    // this will cause the VideoPreview
    // component to render with the mediaBlobUrl
    // as the source
    _selectVideo(qid, mediaBlobUrl);

    // If we have a blob url, hide the camera recorder
    if (mediaBlobUrl !== null) {
      _hideCameraRecorder(qid);
    }
  }, [mediaBlobUrl]);

  const [isCountingDown, setIsCountingDown] = useState(false);

  // Keep track of if we're recording
  const [isRecording, setIsRecording] = useState(false);

  // Function to initiate recording
  const handleStartRecording = () => {
    setIsCountingDown(true);
    // Wait three seconds (the time of the countdown)
    // until we actually start recording
    const wait = new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 3000);
    });

    wait.then(() => {
      setIsCountingDown(false);
      startRecording();
      setIsRecording(true);

      // Dispatch a null object URL just in case the
      // user is recording a video to replace their
      // last one
      _selectVideo(qid, null);
    });
  };

  const handleStopRecording = () => {
    stopRecording();
    setIsRecording(false);
    _completeRecording(qid);
  };

  return (
    <section className={styles.vpCameraRecordSection}>
      <ViewFinder
        isCountingDown={isCountingDown}
        status={status}
        stream={previewStream}
      />

      <section className={styles.vpCameraButtonsContainer}>
        {!isRecording && mediaBlobUrl === null // idle and ready to record
            && <Button
              appearance="primary"
              className={styles.vpStartRecordingButton}
              onClick={
                () => {
                  _clearUploadedVideo(qid);
                  handleStartRecording();
                }
              }
            >
              Start Recording
            </Button>
        }

        {isRecording // currently recording
            && <Button
              appearance="ghost"
              className={styles.vpStopRecordingButton}
              onClick={() => {
                handleStopRecording();
              }}
            >
              Stop Recording
            </Button>
        }
      </section>
    </section>
  );
};

CameraRecord.propTypes = {
  _clearUploadedVideo: PropTypes.func,
  _completeRecording: PropTypes.func,
  _hideCameraRecorder: PropTypes.func,
  _selectVideo: PropTypes.func,
  qid: PropTypes.string,
  shouldShowCameraRecorder: PropTypes.bool,
  signedUrl: PropTypes.string,
  urlType: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  return {
    shouldShowCameraRecorder: getShouldShowCameraRecorder(state, ownProps.qid),
    signedUrl: getPreSignedUrlForUpload(state, ownProps.qid),
  };
}

const mapDispatchToProps = {
  _clearUploadedVideo: clearUploadedVideo,
  _completeRecording: completeRecording,
  _hideCameraRecorder: hideCameraRecorder,
  _selectVideo: selectVideo,
};

export default connect(mapStateToProps, mapDispatchToProps)(CameraRecord);



// WEBPACK FOOTER //
// ./src/components/CameraRecord/CameraRecord.jsx